import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/core/user/user.service';
import {
  ToasterService,
  ToastStatus,
} from 'src/app/core/toaster/toaster.service';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss'],
})
export class UserModalComponent implements OnInit {
  userForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<UserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private userService: UserService,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.userForm = this.fb.group({
      username: [this.data.user?.username || '', Validators.required],
      name: [this.data.user?.name || '', Validators.required],
      email: [
        this.data.user?.email || '',
        [Validators.required, Validators.email],
      ],
      password: [
        this.data.user?.password || '',
        this.data.isEdit ? [] : [Validators.required, Validators.minLength(6)],
      ],
      phone: [this.data.user?.phone || ''],
      address: [this.data.user?.address || ''],
      role: [this.data.user?.role || 'branch', Validators.required],
      description: [this.data.user?.description || ''],
      vatNumber: [this.data.user?.vatNumber || ''],
      pricePerBoardErect: [this.data.user?.pricePerBoardErect || null],
      pricePerBoardChange: [this.data.user?.pricePerBoardChange || null],
      status: [this.data.user?.status || 'Active', Validators.required],
    });

    if (this.data.isEdit) {
      this.userForm.get('username')?.disable();
      this.userForm.get('password')?.disable();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.userForm.valid) {
      const userData = this.userForm.value;
      if (this.data.isEdit) {
        // Remove password from update payload if it's empty or disabled
        delete userData.password;
        delete userData.username;

        this.userService.updateUser(this.data.user.id, userData).subscribe(
          () => {
            this.toasterService.toast(
              ToastStatus.success,
              'User updated successfully'
            );
            this.dialogRef.close(true);
          },
          error => {
            this.toasterService.toast(
              ToastStatus.error,
              error.error.message || 'Error updating user'
            );
          }
        );
      } else {
        this.userService.createUser(userData).subscribe(
          () => {
            this.toasterService.toast(
              ToastStatus.success,
              'User created successfully'
            );
            this.dialogRef.close(true);
          },
          error => {
            this.toasterService.toast(
              ToastStatus.error,
              error.error.message || 'Error creating user'
            );
          }
        );
      }
    }
  }
}
